export default Object.freeze({
  // 운영관리 > SMS 관리
  PAGE_TITLE: 'SMS 관리',
  TAB_DISPATCH: 'SMS 발송',
  TAB_TEMPLATECONFIG: 'SMS 템플릿 설정',
  TAB_AUTOSMS: '자동SMS 설정',
  TAB_SENDLIST: '자동SMS 발송내역 조회',
  TAB_USAGELIST: '자동SMS 사용내역 조회',
  MESSAGETYPE_LABEL: '발송 유형',
  MESSAGETYPE_ALL: '전체',
  MESSAGETYPE_SMS: 'SMS',
  MESSAGETYPE_LMS: 'LMS',
  USAGELIST_NOTICE1: 'ⓘ 자동 SMS 중 무료 항목 발송 시 사용한 금액을 조회할 수 있습니다.',
  USAGELIST_NOTICE2: 'ⓘ 자동 SMS 유료항목에 대한 사용내역은 수동SMS 사용내역과 함께 NHN Cloud에서 조회하실 수 있습니다.',
  USAGELIST_NOTICE3: 'Ⓘ 매달 7일 이후에 전월의 사용량을 확인할 수 있습니다.',
  SUMMARY_TABLE_TITLE: '총 사용금액 합계',
  DETAIL_TABLE_TITLE: '사용금액 상세'
})